import { FC, PropsWithChildren } from 'react';
import { Card, CardFooterProps } from '../../card';

/**
 * ModalFooter is a functional component used to render the footer section
 * within a modal. It wraps children elements inside a Card.Footer component.
 */
export const ModalFooter: FC<PropsWithChildren & CardFooterProps> = ({ children, ...props }) => {
  return (
    <Card.Footer {...props}>
      <Card.FooterContent>
        {children}
      </Card.FooterContent>
    </Card.Footer>
  );
};